// extracted by mini-css-extract-plugin
export default {"scrollContainer":"lKCazZ6_jjfaP3WxpLJ2","disablePointer":"J67nGM4f6PthmuWq5YCk","hideScrollbarContent":"SgwJiSRNqyg1Imu0R5Dx"};